import { SVGProps } from "react";

const DownloadIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24, stroke = "black" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
    >
      <g clipPath="url(#a)">
        <mask
          id="b"
          width="17"
          height="17"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#fff"
            d="M5.833 11.134v5.334H.5v-16h16v16h-5.333v-5.334H5.833Z"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fill="#000"
            fillRule="evenodd"
            d="M1.966 8.135a4.2 4.2 0 0 0 4.2 4.2h6a2.867 2.867 0 1 0-1.074-5.526.868.868 0 0 1-1.114-.44 4.2 4.2 0 0 0-8.012 1.766Zm4.2 5a5 5 0 1 1 4.538-7.102.068.068 0 0 0 .088.035 3.667 3.667 0 1 1 1.374 7.067h-6Z"
            clipRule="evenodd"
          />
        </g>
        <path
          fill="#000"
          fillRule="evenodd"
          d="M8.9 8.467v5.334h-.8V8.467h.8Z"
          clipRule="evenodd"
        />
        <path
          fill="#000"
          fillRule="evenodd"
          d="M10.5 13.8h-4l2 2 2-2Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.5.468h16v16H.5z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DownloadIcon;
